import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Subject, Observable, Subscription } from "rxjs";
import { tap, finalize } from "rxjs/operators";
import { Permit } from "../../../../common/models/permit.model";
import { WellDirection, CasingPlanModel } from "../../../../form-controls/components/new-casing-plan/models/casing-plan.model";
import { DocumentManagementService, IAzureBlobSasToken, IUploadFile } from "../../../../common/services/document-management.service";


@Component({
    selector: 'schematics-preview',
    templateUrl: './schematics-preview.component.html',
    styleUrls: ['./schematics-preview.component.scss'],
    standalone: false
})
export class SchematicsPreviewComponent implements OnInit, OnDestroy {


    get applicationData(): { applicationNumber: string, wellName: string, wellNumber: string } {
        return {
            applicationNumber: this.applicationNumber,
            wellName: this.wellName,
            wellNumber: this.wellNumber
        };
    }

    get applicationNumber(): string {
        if (this.permit == null) return "";
        return this.permit.id;
    }
    private dialogSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


    @Output() permitChanged: EventEmitter<Permit> = new EventEmitter<Permit>();

    @Input() permit: Permit = null;

    get casingPlan(): CasingPlanModel {
        if (this.permit == null || this.permit.casingPlan == null) return null;
        return this.permit.casingPlan;
    }

    savingDrawing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    get showDialog(): boolean {
        return this.dialogSubject.value;
    }

    subscriptions: Subscription = new Subscription();

    get wellDirection(): WellDirection {
        if (this.permit == null || this.permit.casingPlan == null) return WellDirection.Vertical;
        return this.permit.casingPlan.wellDirection;
    }

    get wellName(): string {
        if (this.permit == null) return "";
        return this.permit.wellName;
    }

    get wellNumber(): string {
        if (this.permit == null) return "";
        return this.permit.wellNumber;
    }

    constructor(private _docService: DocumentManagementService) { }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.subscriptions != null) this.subscriptions.unsubscribe();
    }

    private blobToFile(blob: Blob, fileName: string): File {
        const b: any = blob;
        b.lastModifiedDate = new Date();
        b.name = fileName;
        return b as File;
    }

    cancel(): void {
        this.toggle(false);
    }

    private encodeDrawing(imageType: string): string {
        const el = document.getElementById("canvas");
        if (el) {
            const canvas = <HTMLCanvasElement>el;
            const url = canvas.toDataURL(imageType, 1.0);
            return url;
        }
        return "";
    }

    save(): void {
        const fileName = `${this.applicationNumber}_schematic.png`;
        const img = this.encodeDrawing("image/png");
        this.savingDrawing.next(true);
        const save$ = this.saveDrawings(fileName, img).pipe(
            tap((token: IAzureBlobSasToken) => {
                if (this.casingPlan != null) {
                    this.permit.casingPlan.schematic = token.blobUri;
                    this.permitChanged.emit(this.permit);
                }
            }),
            finalize(() => {
                this.toggle(false);
                this.savingDrawing.next(false);

            })
        ).subscribe(
            () => { },
            (error) => { console.error(error); }
        );
        this.subscriptions.add(save$);
    }

    saveDrawings(name: string, url: string): Observable<IAzureBlobSasToken> {
        var data = url.split(','), mime = data[0].match(/:(.*?);/)[1], bstr = atob(data[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        const fileName = name.replace(" ", "_");
        let blobFile: File;
		blobFile = new File([u8arr], fileName, { type: mime });
        const file = { fileName: `${fileName}`, rawFile: blobFile } as IUploadFile;
        return this.uploadFile(file);
    }


    toggle(show: boolean): void {
        this.dialogSubject.next(show);
    }


    private uploadFile(file: IUploadFile): Observable<IAzureBlobSasToken> {
        const uploadComplete = new Subject<IAzureBlobSasToken>();
        return this._docService.provision(file.rawFile.name).pipe(
            tap((data: any) => {
                this._docService.processProvisionedFile(file, data, uploadComplete);
            })
        );
    }
}
